import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CAR_CONTRACTS } from "../../../service/ApolloClient/ApolloQueries";
import NumberFormat from "react-number-format";
import { MUTATION_REMOVE_CAR_CONTRACT } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { confirmAlert } from "react-confirm-alert";
import showDocumentType from "../../../utility/showDocumentType"; // Import

class CarContractList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: [
        {
          title: "#",
          field: "id",
          render: (rowData) => {
            return (
              <a href={`/car-contract/edit/${rowData.id}`}>{rowData.id}</a>
            );
          },
        },
        {
          title: "خریدار",
          field: "buyer_fullname",
          render: (rowData) =>
            rowData.buyer_id ? (
              <a href={`/person/edit/${rowData.buyer_id}`}>
                {rowData.buyer_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "فروشنده",
          field: "seller_fullname",
          render: (rowData) =>
            rowData.seller_id ? (
              <a href={`/person/edit/${rowData.seller_id}`}>
                {rowData.seller_fullname}
              </a>
            ) : (
              "مشخص نشده"
            ),
        },
        {
          title: "اتومبیل",
          field: "car_type",
        },
        {
          title: "قیمت",
          field: "price",
          render: (rowData) => (
            <NumberFormat
              value={rowData.price}
              thousandSeparator={true}
              displayType={"text"}
            />
          ),
        },
        {
          title: "نوع معامله",
          field: "document_type",
          render: (rowData) => showDocumentType(rowData.document_type),
        },

        {
          title: "تاریخ قرارداد",
          field: "document_date_fa",
          render: (rowData) => rowData.document_date_fa,
        },
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_CAR_CONTRACTS,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          user: parseInt(this.props.user),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.carContracts.data,
          page: query.page,
          totalCount: data.carContracts.total,
        };
      });
  };

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_CAR_CONTRACT,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeCarContract;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data } = this.state;
    let title = "معاملات ماشین" + " " + (this.props.name ? this.props.name : "");
    return (
      <MaterialTableRtl
        tableRef={this.tableRef}
        columns={columns}
        data={this.remoteData}
        editLink={"/car-contract/edit/"}
        handleRemove={this.handleRemove}
        needExport={true}
        title={title}
        pdfName={this.props.pdfName ? this.props.pdfName : title}
      />
    );
  }
}

export default CarContractList;
